import { useEffect, useState } from "react";
import "../App.css";

const Policy = ({ s }) => {
  const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    fetch(s)
      .then((response) => response.text())
      .then((html) => setHtmlContent(html))
      .catch((error) => console.error("Error fetching HTML:", error));
  }, []);

  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default Policy;
